export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const IS_SESSION_REDEEM = 'IS_SESSION_REDEEM';
export const LINK_SURVEY = 'linkSurvey';
